/**
 * Template: Collection
 * ------------------------------------------------------------------------------
 * Highly coupled scripts to power the collection page functionality.
 *
 * @namespace collection
 */
import StickyFilters from '~/components/sticky-filters';
import '~/components/show-more'

import '../../styles/templates/collection.scss';
import '../../styles/components/component-filter.scss';
import '../../styles/components/pagination.scss';
import '../../styles/components/typology-filters.scss';
  /**
   * DOM selectors.
   */
  const selectors = {
    collectionDesktopFilters: '.template-collection__tools-container'
  }
    /**
   * DOM node selectors.
   */
    const nodeSelectors = {
      collectionDesktopFilters: document.querySelector(selectors.collectionDesktopFilters),
    };

document.addEventListener('DOMContentLoaded', () => {
  if(nodeSelectors.collectionDesktopFilters !== null) {
    StickyFilters().init();
  }
});
